import http from "./httpService";

export const softwareVersionBaseEndPoint = "/versions";

export function getSoftwareVersion(hostname) {
  return http.get(`${softwareVersionBaseEndPoint}/${hostname}/`);
}
